<template>
    <transition name="slide-fade">
        <div class="modal mx-auto" :class="{'open' : open}" v-if="open">
            <div class="modal-content px-5">
                <div class="ic-success relative top-12 ">
                    <img class="mx-auto " :src="getSuccessImg()"/>
                </div>
                <div class="bg-white w-full rounded-40 p-4 pt-16 border-b-8 border-a-black-080909">
                    <div class="font-SemiBold text-center text-20 text-a-black-080909" v-html="title"></div>
                    <div class="font-Text text-center text-16 text-a-gray-666666 pt-5 pb-7" v-html="message"></div>
                    <button class="font-SemiBold text-16 text-white w-full rounded-40 pt-5 pb-4 font-SemiBold" :style="backgroundStyle" @click="clickOk()">
                        {{btnOk}}
                    </button>
                </div>
            </div>
        </div>
    </transition>
    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import Util from "@/helper/Utility.js";
// import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: "SuccessModal",
    // mixins: [LocaleMixin],
    props: {
        controller: Object,
    },
    data: function() {
        return {
            open: false,

            title: '',
            message: '',
            blobConfig: '',
            btnOk: '',
            btnCancel: '',
            busModal: null,

            backgroundStyle: {
                backgroundColor : '',
            },
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    watch: {
        '$route.path': function() {
            if (this.open) {
                this.hide();
            }
        },
    },
    methods: {
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.blobConfig = config.blobConfig;
            this.btnOk = config.btnOk;
            this.btnCancel = config.btnCancel;

            if (Util.isEmptyStr(this.btnOk)) {
                // this.btnOk = this.lbl.button.confirm;
            }
            if (Util.isEmptyStr(this.btnCancel)) {
                // this.btnCancel = this.lbl.button.cancel;
            }

            document.body.classList.add('not-scroll');
            this.setupTheme();
            this.open = true;
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk();
        },
        clickCancel: function() {
            this.hide();
            this.controller.sendCallbackCancel();
        },
        setupTheme: function() {
            this.backgroundStyle.backgroundColor = this.blobConfig.appConfig.blobConfig.btn_color;
        },
        getSuccessImg: function() {
            return `${this.blobConfig.blobUrl}/image/${this.blobConfig.appConfig.blobConfig.icon_popup_success}`;
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/modal.scss";
    @import '../../../style/base.scss';
    .modal {
        max-width: 414px;
        @extend %modal;
        .modal-content {
            width: 100%;
            max-width: 414px;
        }
    }
    .ic-success{
        img{
            height: 168px;
        }
    }
    .font-SemiBold {
        font-family: $ff-semi;
    }
    .font-Medium {
        font-family: $ff-Medium;
    }
    .font-Text {
        font-family: $ff-text;
    }
</style>
